/**
 * Whether the browser's page visibility API is available or not.
 */
export const hasPageVisibilityAPI = (): boolean => 'visibilityState' in document;

export const isPageHidden = (): boolean =>
  hasPageVisibilityAPI() ? document.visibilityState === 'hidden' : false;
